import { Chip, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { CouponGiftDTO, CouponGiftDTOStatusEnum } from 'probonio-shared-ui/api';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SortByDef } from '../../../../component/table/sortMapper';
import { StatusColor } from '../../../types/statusColors';

export function useGiftsColumns(): (MRT_ColumnDef<CouponGiftDTO> & SortByDef)[] {
  const { t } = useTranslation('couponsModule');

  return useMemo(
    (): (MRT_ColumnDef<CouponGiftDTO> & SortByDef)[] => [
      {
        accessorKey: 'payoutDate',
        header: t('benefitsModule:userGiftsPage.payoutDate'),
        Cell: ({ cell }) => t('common:date', { date: new Date(cell.getValue<string>()) }),
      },
      {
        accessorKey: 'occasion',
        header: t('benefitsModule:userGiftsPage.occasion'),
        Cell: ({ cell }) => t(`giftOccasions.${cell.getValue<string>()}`),
        enableSorting: false,
      },
      {
        accessorKey: 'recurring',
        header: t('benefitsModule:userGiftsPage.recurring'),
        maxSize: 160,
        Cell: ({ cell }) => (cell.getValue<boolean>() ? t('common:yes') : t('common:no')),
        enableSorting: false,
      },
      {
        accessorKey: 'amount',
        header: t('benefitsModule:userGiftsPage.amount'),
        maxSize: 80,
        Cell: ({ cell, row }) => {
          return <Typography variant="body2">{t('common:money', { money: cell.getValue<number>() })}</Typography>;
        },
      },
      {
        accessorKey: 'status',
        header: t('benefitsModule:userGiftsPage.status'),
        minSize: 0,
        size: 0,
        Cell: ({ row }) => {
          let text = '';
          let color: StatusColor | undefined;

          const status = row.original.status;

          if (status === CouponGiftDTOStatusEnum.Available || status === CouponGiftDTOStatusEnum.Redeemed) {
            text = t('benefitsModule:GIFTS.completed');
            color = 'success';
          } else if (status === CouponGiftDTOStatusEnum.Pending) {
            text = t('benefitsModule:GIFTS.paymentPending');
            color = 'info';
          } else if (status === CouponGiftDTOStatusEnum.PaymentFailed) {
            text = t('benefitsModule:GIFTS.paymentFailed');
            color = 'warning';
          }

          return color ? <Chip label={text} variant="filled" color={color} size="small" /> : null;
        },
        enableSorting: false,
      },
    ],
    [t],
  );
}
